// TODO: https://github.com/combinaut/sparkle/issues/32950 removes this shim after its callers migrate.
import "./utilities_namespace.js";
import {
  isSparkleDomain,
  detectPublishingDomain,
  detectCurrentWebsite,
  detectEmbeddingEndpoint,
  detectURLMap,
  detectEmbeddingUrlLocale,
} from "#/shared/embedding/publishing-domain";

// Forwards to shared/embedding/publishing-domain.js.
Object.assign(Sparkle.Embed.Utilities, {
  isSparkleDomain,
  detectPublishingDomain,
  detectCurrentWebsite,
  detectEmbeddingEndpoint,
  detectURLMap,
  detectEmbeddingUrlLocale,
});
